import { useEffect, useState } from 'react';
import client from '../../api/client';
import Spinner from '../Global/Spinner';
import { useUser } from '../../context/UserContext';
import formatDate from '../../utils/formatDate';
import { Link } from 'react-router-dom';
import ArchiveList from './ArchiveList';

export default function BlogList() {
	// choose random image

	const [blogPosts, setBlogPosts] = useState([]);
	const [newPost, setNewPost] = useState({});
	const [loading, setLoading] = useState(false);
	const { user } = useUser();
	const getBlogPosts = async () => {
		try {
			setLoading(true);
			const { data } = await client.get('/blog');
			console.log({ data });
			setBlogPosts(data.blogPosts);

			setLoading(false);
		} catch (error) {
			return console.error(error);
		}
		return;
	};
	useEffect(() => {
		getBlogPosts();
	}, []);

	if (loading) return <Spinner />;

	return (
		<div className='bg-white py-24 sm:py-32'>
			{blogPosts && blogPosts.length > 0 && (
				<div className='mx-auto grid max-w-7xl grid-cols-1 gap-x-8 gap-y-12 px-6 sm:gap-y-16 lg:grid-cols-2 lg:px-8'>
					<article className='mx-auto w-full max-w-2xl lg:mx-0 lg:max-w-lg'>
						<h2 className='text-4xl font-bold tracking-tight text-gray-800 sm:text-6xl mb-4'>
							Featured Post
						</h2>
						<time
							dateTime={blogPosts[0].createdAt}
							className='block text-sm leading-6 text-gray-600'
						>
							{formatDate(blogPosts[0].createdAt)}
						</time>
						<h2
							id='featured-post'
							className='mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl'
						>
							{blogPosts[0].title}
						</h2>
						<p className='mt-4 text-lg leading-8 text-gray-600'>
							{blogPosts[0].description}
						</p>
						<div className='mt-4 flex flex-col justify-between gap-6 sm:mt-8 sm:flex-row-reverse sm:gap-8 lg:mt-4 lg:flex-col'>
							<div className='flex'>
								<Link
									to={`/blog/${blogPosts[0]._id}`}
									className='text-sm font-semibold leading-6 text-primary-600'
									aria-describedby='featured-post'
								>
									Continue reading <span aria-hidden='true'>&rarr;</span>
								</Link>
							</div>
							<div className='flex lg:border-t lg:border-gray-900/10 lg:pt-8'>
								<Link
									to={`/blog/${blogPosts[0]._id}`}
									className='flex gap-x-2.5 text-sm font-semibold leading-6 text-gray-900'
								>
									<img
										src={blogPosts[0].img}
										alt=''
										className='h-6 w-6 flex-none rounded-full bg-gray-50'
									/>
									{blogPosts[0].title}
								</Link>
							</div>
							<div className='mt-12 sm:block max-w-sm hidden'>
								<ArchiveList />
							</div>
						</div>
					</article>
					<div className='mx-auto w-full max-w-2xl border-t border-gray-900/10 pt-12 sm:pt-16 lg:mx-0 lg:max-w-none lg:border-t-0 lg:pt-0'>
						<div className='-my-12 divide-y divide-gray-900/10'>
							<h2 className='text-4xl font-bold tracking-tight text-gray-800 sm:text-3xl mb-4'>
								Latest Posts
							</h2>
							{blogPosts &&
								blogPosts.map((post, i) => {
									return (
										<article
											key={post?._id}
											className='py-12'
										>
											<div className='group relative max-w-xl'>
												<time
													dateTime={post?.createdAt}
													className='block text-sm leading-6 text-gray-600'
												>
													{formatDate(post?.createdAt, { monthLength: 'long' })}
												</time>
												<h2 className='mt-2 text-lg font-semibold text-gray-900 group-hover:text-primary-600'>
													<Link to={`/blog/${post._id}`}>
														<span className='absolute inset-0' />
														{post?.title}
													</Link>
												</h2>
												<p className='mt-4 text-sm leading-6 text-gray-600'>
													{post?.description}
												</p>
											</div>
											<div className='mt-4 flex'>
												<Link
													to={`/blog/${post._id}`}
													className='relative flex gap-x-2.5 text-sm font-semibold
												leading-6 text-gray-900'
												>
													<img
														src={post?.img}
														alt=''
														className='h-6 w-6 flex-none rounded-full bg-gray-50'
													/>
													{post?.title}
												</Link>
											</div>
										</article>
									);
								})}
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
